var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 104,
    viewBox: "0 0 97 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 87.4962C25.2345 90.878 28.4019 89.9313 30.7912 93.2407C31.0655 93.6204 32.4663 95.5621 32.1862 98.054C31.9625 100.04 30.7615 101.572 30.006 102.246C25.4133 106.34 12.7757 101.331 5.53812 95.8533C3.96024 94.6588 -0.273648 91.4551 0.579071 89.1793C0.928546 88.2471 2.01367 87.7837 2.79241 87.463C6.23532 86.0449 9.80638 86.9862 11.8281 87.4962Z",
    fill: "url(#paint0_linear_33918_141544)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2207 4.51562H50.3672V21.7586H53.2207V4.51562Z",
    fill: "url(#paint1_linear_33918_141544)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6469 31.2843H41.9401C40.4868 31.2843 39.3091 30.1998 39.3091 28.8616V22.3759C39.3091 21.0376 40.4868 19.9531 41.9401 19.9531H61.6469C63.1002 19.9531 64.2779 21.0376 64.2779 22.3759V28.8616C64.2773 30.1998 63.0996 31.2843 61.6469 31.2843Z",
    fill: "url(#paint2_linear_33918_141544)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4661 68.9753C96.4661 79.4504 87.244 87.9426 75.8686 87.9426H27.7186C16.3898 87.9426 7.12109 79.4075 7.12109 68.9753V59.1223C7.12109 40.5615 23.6122 25.375 43.7688 25.375H59.819C79.975 25.375 96.4667 40.561 96.4667 59.1223L96.4661 68.9753Z",
    fill: "url(#paint3_linear_33918_141544)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.413 67.1776C81.244 67.7097 79.9335 67.9886 78.602 67.9886H24.9856C23.6541 67.9886 22.3435 67.7097 21.1745 67.1776C18.303 65.8705 16.6826 63.231 17.088 60.5235L17.1177 60.3266C18.4917 51.1554 27.5117 44.1044 38.5702 43.5745C43.2491 43.3503 48.1593 43.2344 53.2808 43.2618C57.2928 43.2832 61.1708 43.3916 64.9049 43.5686C76.0054 44.0953 85.0918 51.1184 86.471 60.3245C86.4809 60.3905 86.4908 60.457 86.5007 60.5229C86.9055 63.231 85.2846 65.8705 82.413 67.1776Z",
    fill: "url(#paint4_linear_33918_141544)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.663 65.968C43.2468 65.968 47.7734 61.7997 47.7734 56.6578C47.7734 51.516 43.2468 47.3477 37.663 47.3477C32.0793 47.3477 27.5527 51.516 27.5527 56.6578C27.5527 61.7997 32.0793 65.968 37.663 65.968Z",
    fill: "url(#paint5_radial_33918_141544)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6631 63.3416C41.6709 63.3416 44.9199 60.3497 44.9199 56.6591C44.9199 52.9684 41.6709 49.9766 37.6631 49.9766C33.6553 49.9766 30.4062 52.9684 30.4062 56.6591C30.4062 60.3497 33.6553 63.3416 37.6631 63.3416Z",
    fill: "#EEFDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6632 62.2758C41.0293 62.2758 43.7581 59.763 43.7581 56.6633C43.7581 53.5636 41.0293 51.0508 37.6632 51.0508C34.2971 51.0508 31.5684 53.5636 31.5684 56.6633C31.5684 59.763 34.2971 62.2758 37.6632 62.2758Z",
    fill: "url(#paint6_linear_33918_141544)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5675 55.2C41.5675 56.3484 40.5569 57.279 39.3098 57.279C38.0628 57.279 37.0522 56.3478 37.0522 55.2C37.0522 54.0522 38.0628 53.1211 39.3098 53.1211C40.5569 53.1211 41.5675 54.0522 41.5675 55.2Z",
    fill: "#EEFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7624 61.7884C37.26 61.7884 37.6635 61.4169 37.6635 60.9587C37.6635 60.5004 37.26 60.1289 36.7624 60.1289C36.2647 60.1289 35.8613 60.5004 35.8613 60.9587C35.8613 61.4169 36.2647 61.7884 36.7624 61.7884Z",
    fill: "#EEFDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5279 59.7154C34.5279 59.9444 34.3264 60.13 34.0777 60.13C33.829 60.13 33.6274 59.9444 33.6274 59.7154C33.6274 59.4864 33.829 59.3008 34.0777 59.3008C34.3264 59.3008 34.5279 59.4869 34.5279 59.7154Z",
    fill: "#EEFDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9755 65.968C70.5593 65.968 75.0859 61.7997 75.0859 56.6578C75.0859 51.516 70.5593 47.3477 64.9755 47.3477C59.3918 47.3477 54.8652 51.516 54.8652 56.6578C54.8652 61.7997 59.3918 65.968 64.9755 65.968Z",
    fill: "url(#paint7_radial_33918_141544)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9751 63.3416C68.983 63.3416 72.232 60.3497 72.232 56.6591C72.232 52.9684 68.983 49.9766 64.9751 49.9766C60.9673 49.9766 57.7183 52.9684 57.7183 56.6591C57.7183 60.3497 60.9673 63.3416 64.9751 63.3416Z",
    fill: "#EEFDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9752 62.2758C68.3413 62.2758 71.0701 59.763 71.0701 56.6633C71.0701 53.5636 68.3413 51.0508 64.9752 51.0508C61.6091 51.0508 58.8804 53.5636 58.8804 56.6633C58.8804 59.763 61.6091 62.2758 64.9752 62.2758Z",
    fill: "url(#paint8_linear_33918_141544)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8805 55.2C68.8805 56.3484 67.8694 57.279 66.6229 57.279C65.3765 57.279 64.3647 56.3478 64.3647 55.2C64.3647 54.0522 65.3759 53.1211 66.6229 53.1211C67.87 53.1211 68.8805 54.0522 68.8805 55.2Z",
    fill: "#EEFDFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0744 61.7884C64.5721 61.7884 64.9755 61.4169 64.9755 60.9587C64.9755 60.5004 64.5721 60.1289 64.0744 60.1289C63.5768 60.1289 63.1733 60.5004 63.1733 60.9587C63.1733 61.4169 63.5768 61.7884 64.0744 61.7884Z",
    fill: "#EEFDFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8404 59.7154C61.8404 59.9444 61.6389 60.13 61.3902 60.13C61.1415 60.13 60.9399 59.9444 60.9399 59.7154C60.9399 59.4864 61.1415 59.3008 61.3902 59.3008C61.6389 59.3008 61.8404 59.4869 61.8404 59.7154Z",
    fill: "#EEFDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4493 3.36674C55.4493 5.22577 53.8126 6.73349 51.7932 6.73349C49.7744 6.73349 48.1377 5.22631 48.1377 3.36674C48.1377 1.50771 49.7744 0 51.7932 0C53.8126 0 55.4493 1.50718 55.4493 3.36674Z",
    fill: "url(#paint9_linear_33918_141544)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3351 2.05394C54.3351 2.62087 53.836 3.08 53.2203 3.08C52.6046 3.08 52.1055 2.62034 52.1055 2.05394C52.1055 1.48701 52.6046 1.02734 53.2203 1.02734C53.836 1.02788 54.3351 1.48701 54.3351 2.05394Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2724 36.1688C83.3207 37.7403 81.9275 39.6203 80.3315 39.7807C78.8358 39.9314 77.6412 38.524 76.4093 37.0726C75.1948 35.6421 72.5394 31.9669 73.5972 30.9275C74.991 29.5571 83.1576 32.4609 83.2724 36.1688Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6068 30.1795C70.3084 30.1795 70.8771 29.6557 70.8771 29.0096C70.8771 28.3636 70.3084 27.8398 69.6068 27.8398C68.9052 27.8398 68.3364 28.3636 68.3364 29.0096C68.3364 29.6557 68.9052 30.1795 69.6068 30.1795Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0911 57.9683C82.6834 58.2333 79.8415 52.9018 72.2125 48.2795C69.5309 46.6543 66.8836 45.4963 67.0409 45.1594C67.2004 44.8178 70.1821 45.4534 72.569 46.473C80.1747 49.7223 83.5757 57.6535 83.0911 57.9683Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5556 23.3069C63.4648 23.3187 63.4065 22.8269 62.9615 22.0669C62.9615 22.0669 62.7536 21.7113 62.516 21.4098C61.75 20.439 59.1534 20.4605 58.9496 20.4621C54.9056 20.4943 52.3055 20.2583 52.3066 20.2808C52.3072 20.2996 54.2037 20.2642 55.5935 20.2384C59.514 20.1649 61.8496 19.9708 62.8509 20.9378C63.2662 21.339 63.4753 21.8614 63.4753 21.8614C63.7583 22.5705 63.664 23.2925 63.5556 23.3069Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7148 71.9818C62.6157 72.8738 61.8096 73.5609 60.8404 73.6467L47.4474 74.8358C46.4787 74.9216 45.5445 74.3901 45.262 73.5319C45.1362 73.1506 45.0395 72.7574 44.9737 72.353C44.9556 72.2414 44.9877 72.1277 45.0634 72.0381C45.1391 71.9491 45.2509 71.8928 45.3732 71.8815L62.2698 70.3808C62.3903 70.3701 62.5097 70.4055 62.6012 70.4784C62.6926 70.5513 62.7468 70.6559 62.752 70.767C62.7724 71.1784 62.759 71.5839 62.7148 71.9818Z",
    fill: "#EEFDFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7149 71.9844C62.2868 75.8076 58.986 78.9506 54.6741 79.3298C50.421 79.7091 46.5797 77.2804 45.3169 73.6841C45.6541 74.4527 46.5313 74.921 47.4464 74.8367L60.8429 73.6492C61.8109 73.5607 62.6136 72.8758 62.7149 71.9844Z",
    fill: "url(#paint10_linear_33918_141544)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8163 99.682C83.8163 99.7952 83.8163 99.9036 83.8111 100.007C83.7685 101.042 83.5059 101.82 83.3777 102.17C79.6913 112.54 77.4821 118.009 74.3846 122.433C73.8499 123.197 73.2878 123.93 72.6832 124.65C71.8916 125.61 71.0249 126.546 70.0616 127.512C67.9216 129.656 64.6849 130.626 63.6417 130.961C59.8272 132.203 56.4565 131.976 54.2152 131.996H53.8244C51.5772 131.976 48.2124 132.203 44.3979 130.961C43.3547 130.626 40.1127 129.656 37.978 127.512C32.0928 121.615 29.83 116.713 24.6618 102.17C24.5389 101.835 24.2926 101.11 24.2337 100.14C24.218 99.859 24.2122 99.5785 24.2285 99.2975C24.3409 97.5586 25.1057 95.8535 26.4651 94.297C28.7926 91.627 32.3876 90.1638 36.106 90.1487L54.023 90.0796L71.6138 90.0157C75.4126 90.0007 79.0931 91.4693 81.5057 94.1736C82.6723 95.4839 83.4156 96.8978 83.6887 98.3562C83.726 98.5632 83.7581 98.775 83.7796 98.9821C83.8 99.2138 83.8163 99.4455 83.8163 99.682Z",
    fill: "url(#paint11_linear_33918_141544)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0191 90.0796L36.1021 90.1487C32.3837 90.1638 28.7888 91.627 26.4612 94.297C25.1024 95.854 24.3376 97.5586 24.2246 99.2975C24.3155 97.5141 25.1129 95.765 26.5306 94.1736C28.9379 91.4687 32.6242 90.0007 36.4225 90.0157L54.0191 90.0796Z",
    fill: "url(#paint12_linear_33918_141544)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8274 114.389C71.5658 101.591 69.6851 99.0601 72.4587 96.0157C72.7773 95.666 74.4041 93.8805 77.0794 93.4246C79.2112 93.0614 81.1461 93.6901 82.0617 94.1674C87.623 97.0686 85.9729 109.647 82.3093 117.587C81.5107 119.318 79.3678 123.963 76.7561 123.852C75.6861 123.806 74.8969 122.978 74.3436 122.381C71.8943 119.74 71.867 116.319 71.8274 114.389Z",
    fill: "url(#paint13_linear_33918_141544)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3844 122.435C73.8497 123.198 73.2876 123.932 72.683 124.651C72.4902 124.469 72.319 124.287 72.164 124.119C69.7136 121.479 69.6868 118.06 69.6496 116.129C69.3875 103.329 67.5044 100.802 70.281 97.7572C70.4842 97.5308 71.228 96.7177 72.4372 96.043C69.6979 99.0777 71.5653 101.63 71.8274 114.39C71.8647 116.321 71.8967 119.74 74.3418 122.386C74.3576 122.4 74.3739 122.415 74.3844 122.435Z",
    fill: "url(#paint14_linear_33918_141544)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2271 103.735C82.1485 102.359 81.8683 101.348 81.308 99.3251C80.5752 96.6787 79.6561 95.3888 80.2532 94.8776C80.6417 94.5451 81.407 94.7698 81.5806 94.8207C84.2075 95.5926 85.0206 100.131 84.9076 102.971C84.8383 104.71 84.3775 106.654 83.6856 106.74C83.5766 106.753 83.3052 106.74 83.1113 106.582C82.3389 105.954 82.2871 104.78 82.2271 103.735Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33918_141544",
    x1: 19.458,
    y1: 95.2769,
    x2: 68.1514,
    y2: 136.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#59BBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33918_141544",
    x1: 45.9788,
    y1: 13.918,
    x2: 54.507,
    y2: 12.5674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#AAE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33918_141544",
    x1: 43.7947,
    y1: 33.9347,
    x2: 57.5989,
    y2: 17.0099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#91DDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33918_141544",
    x1: 21.7923,
    y1: 88.6436,
    x2: 77.0366,
    y2: 28.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B1EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33918_141544",
    x1: 51.6352,
    y1: 67.9086,
    x2: 52.089,
    y2: 45.7373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_33918_141544",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6628 56.6578) scale(10.0057 9.21383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_33918_141544",
    x1: 31.5679,
    y1: 56.6632,
    x2: 43.7581,
    y2: 56.6632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_33918_141544",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9754 56.6578) scale(10.0057 9.21383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_33918_141544",
    x1: 58.88,
    y1: 56.6632,
    x2: 71.0702,
    y2: 56.6632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_33918_141544",
    x1: 44.0977,
    y1: 4.39999,
    x2: 55.384,
    y2: 2.61259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#99DFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_33918_141544",
    x1: 51.4278,
    y1: 76.5189,
    x2: 67.4229,
    y2: 59.1491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714,
    stopColor: "#4FA6AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_33918_141544",
    x1: 34.967,
    y1: 125.221,
    x2: 76.8164,
    y2: 72.1518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64CEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#64CEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7DD5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8004,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_33918_141544",
    x1: 32.5205,
    y1: 100.463,
    x2: 57.6871,
    y2: 68.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_33918_141544",
    x1: 92.188,
    y1: 117.806,
    x2: 59.6468,
    y2: 91.9604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    stopColor: "#9CE4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_33918_141544",
    x1: 61.7189,
    y1: 115.55,
    x2: 85.3183,
    y2: 102.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSuccess);
export default __webpack_public_path__ + "static/media/robot-success.eb846985.svg";
export { ForwardRef as ReactComponent };